import eventHub from './event-hub';

export default {
    eventHub,

    printObservable(...input) {
        let result = input.map(item => JSON.parse(JSON.stringify(item)));
        console.log(...result);
    },

    range() {
        let valid_args = [].slice.call(arguments)
            .filter(arg => !isNaN(Number(arg))).slice(0, 3);
        if (!valid_args.length) throw 'need at least one arguments';
        let result = [], start = 1, end, step = 1;
        if (valid_args.length === 1) {
            end = valid_args[0];
        }
        if (valid_args.length > 1) {
            start = valid_args[0];
            end = valid_args[1];
        }
        if (valid_args.length === 3) {
            step = valid_args[2]
        }
        for (let i = start; i <= end; i += step) {
            result.push(i);
        }
        return result;
    }
};
